import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HomeworkService } from '../../../../services/homework.service';
import { HomeworkLink } from '../../../../models/homework-link';
import { AssetService } from '../../../../services/asset.service';
import { SearchResult } from '../../../../models/search-result';
import { CommunicationService } from '../../../../services/communication.service';
import { Subscription } from 'rxjs';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { ModalService } from '../../../../services/modal.service';
import { PageEditModeFactory } from '../../../../utils/page-edit-modes/page-edit-mode-factory';
import { TestGeneratorFormComponent } from './test-generator-form/test-generator-form.component';
import { TestGeneratorItemComponent } from './test-generator-item/test-generator-item.component';
import { AssetPipe } from '../../../../pipes/asset.pipe';

@Component({
    selector: 'sidebar-test-generator',
    templateUrl: './test-generator.component.html',
    styleUrls: ['./test-generator.component.scss'],
    standalone: true,
    imports: [
        TestGeneratorFormComponent,
        TestGeneratorItemComponent,
        AssetPipe
    ]
})
export class TestGeneratorComponent implements OnInit, OnDestroy {
    @ViewChild(TestGeneratorFormComponent) form?: TestGeneratorFormComponent;
    testsUsed: Array<HomeworkLink>;
    quickLinkResults: Array<SearchResult>;
    subscription: Subscription;
    isTeacher;
    isLoggedIn;
    isDigi4SchoolUser;
    bookAccessCode;
    loading = false;

    constructor(public homeworkService: HomeworkService,
                public applicationStateService: ApplicationStateService,
                public assetService: AssetService,
                private modalService: ModalService,
                private communicationService: CommunicationService,
                private editModeFactory: PageEditModeFactory
    ) {
        this.quickLinkResults = [];

        this.subscription = this.communicationService.homeworkSavedAnnounced$.subscribe((homework: HomeworkLink) => {
            if (this.homeworkService.tests && homework.test) {
                this.homeworkService.tests.unshift(homework as HomeworkLink);
            }
        });
        this.isTeacher = this.applicationStateService.userData.isTeacher;
        this.isLoggedIn = this.applicationStateService.userData.loggedIn;
        this.isDigi4SchoolUser = this.applicationStateService.userData.digi4SchoolUser;
        this.bookAccessCode = this.applicationStateService.userData.bookAccessCode;
    }

    ngOnInit(): void {
        this.homeworkService.getHomeworkLinks(true).then((value => {
            this.homeworkService.tests = value[0];
            this.testsUsed = value[1];
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    hide(): void {
        this.homeworkService.triggerHomeworkEditor();
    }

    openDisabledModal(): void {
        this.modalService.openDisabledHSMModal();
    }

    enableTestsEditMode(): void {
        this.applicationStateService.pageEditMode = this.editModeFactory.createTestsEditMode();
    }

    selectionForDeletionEmpty(): boolean {
        return this.homeworkService.tests.filter(test => test.selectedForDeletion).length === 0;
    }

    editTest(homeworkLink: HomeworkLink) {
        this.form.isEdited = false;
        this.form.editHomework = homeworkLink;
        this.homeworkService.testGeneratorOpened = true;
        this.homeworkService.formAddedTests = homeworkLink.exercises.map(exercise => {
            if (typeof exercise === 'string') {
                const element = new SearchResult();
                element.text = exercise;

                return element;
            }

            return exercise;
        });
        this.form.title = homeworkLink.title;
        homeworkLink.exercises = this.homeworkService.formAddedTests;
        this.homeworkService.syncHomework(homeworkLink);
    }

    deleteHomeworks(): void {
        this.loading = true;
        this.homeworkService.tests.forEach((test) => {
            this.deleteHomework(test);
        });

        this.applicationStateService.pageEditMode = undefined;
    }

    disableTestsEditMode(): void {
        this.homeworkService.tests.forEach((homework) => {
            homework.selectedForDeletion = false;
        });
        this.applicationStateService.pageEditMode = undefined;
    }

    private deleteHomework(test: HomeworkLink) {
        if (!test.selectedForDeletion) {
            return;
        }
        // Homework hasn't been saved
        if (!test.id) {
            this.homeworkService.tests = this.homeworkService.tests.filter(elem => elem !== test);
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        } else {
            // Remove from the backend
            this.homeworkService.removeHomework(test)
                .then(() => {
                    this.homeworkService.tests = this.homeworkService.tests.filter(elem => elem !== test);

                    if (this.selectionForDeletionEmpty()) {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    if (this.selectionForDeletionEmpty()) {
                        this.loading = false;
                    }

                    return;
                });
        }
    }
}
